import styled from 'styled-components';

export const TopbarDiv = styled.div`
    width: 100%;
    height: 100px;
    background-color: #FFF;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
    position: flex;
    text-align: center;
    justify-content: flex-start;
    overflow: hidden;
    padding-left: 20px;
`;